module.exports = __webpack_public_path__ + "img/template_5.d1ed7640.png";